import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import RequestHandler from "./RequestHandler";

const useSweepAccess = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    RequestHandler.get("/User/MenuPermissions").then((response) => {
      if (response?.isSweepAvailable) {
        setHasAccess(true);
      } else {
        history.push("/home");
      }
      setLoading(false);
    });
  }, [history]);

  return { loading, hasAccess };
};

export default useSweepAccess;
